import React from 'react';
import {
    Home as HomeIcon,
    ShoppingCart as ShoppingCartIcon,
    TrendingUp as TrendingUpIcon,
    Box as BoxIcon,
    Search as SearchIcon,
    Factory as FactoryIcon,
    Archive as ArchiveIcon
} from 'lucide-react';
import Home from "./components/Home/Home";
import Ventas from "./components/Sections/Ventas/Ventas";
import ComisionesComercial from "./components/Sections/Comisiones/Comisiones";
import Ordenes from "./components/Sections/Ordenes/Ordenes";
import DetalleOrden from "./components/Sections/Ordenes/DetalleOrden/DetalleOrden";
import BuscadorProducto from "./components/Sections/BuscadorProducto/BuscadorProducto";
import OperadorInyeccion from "./components/Sections/OperadorInyeccion/OperadorInyeccion";
import Almacen from "./components/Sections/BuscadorProducto/Almacen/Almacen";
import RegistrarEmpresa from './components/Sections/RegistrarEmpresa/RegistrarEmpresa';
import RegistrarEmpresaHome from './components/Sections/RegistrarEmpresa/RegistrarEmpresaHome/RegistrarEmpresaHome';
import VerRegistrarEmpresa from './components/Sections/RegistrarEmpresa/VerRegistrarEmpresa/VerRegistrarEmpresa';

export const appRoutes = [
    {
        path: "/",
        element: Home,
        allowedRoles: ['admin', 'almacen', 'inyeccion'],
        title: 'Inicio',
        icon: <HomeIcon size={20} />,
        description: 'Panel principal',
        buttonText: 'Ir al Panel',
        color: 'gray'
    },
    {
        path: "/ventas",
        element: Ventas,
        allowedRoles: ['admin'],
        title: 'Ventas',
        icon: <ShoppingCartIcon size={20} />,
        description: 'Revisa estadísticas y gráficos de ventas',
        buttonText: 'Ver Ventas',
        color: 'green'
    },
    {
        path: "/comisiones",
        element: ComisionesComercial,
        allowedRoles: ['admin'],
        title: 'Comisiones',
        icon: <TrendingUpIcon size={20} />,
        description: 'Historial y detalles de comisiones',
        buttonText: 'Ver Detalles',
        color: 'blue'
    },
    {
        path: "/ordenes",
        element: Ordenes,
        allowedRoles: ['admin'],
        title: 'Órdenes',
        icon: <BoxIcon size={20} />,
        description: 'Resumen y estado de órdenes',
        buttonText: 'Ver Órdenes',
        color: 'red'
    },
    {
        path: "/ordenes/:ordenId",
        element: DetalleOrden,
        allowedRoles: ['admin']
    },
    {
        path: "/buscar-producto",
        element: BuscadorProducto,
        allowedRoles: ['admin', 'almacen'],
        title: 'Buscar Producto',
        icon: <SearchIcon size={20} />,
        description: 'Disponibilidad y stock por código',
        buttonText: 'Buscar',
        color: 'purple'
    },
    {
        path: "/operador-inyeccion",
        element: OperadorInyeccion,
        allowedRoles: ['admin', 'inyeccion'],
        title: 'Operador de Inyección',
        icon: <FactoryIcon size={20} />,
        description: 'Producción y rendimiento por operador',
        buttonText: 'Ver Inyección',
        color: 'teal'
    },
    {
        path: "/almacen",
        element: Almacen,
        allowedRoles: ['almacen', 'admin'],
        title: 'Almacén',
        icon: <ArchiveIcon size={20} />,
        description: 'Gestión y control de inventario',
        buttonText: 'Ver Almacén',
        color: 'warning'
    },
    {
        path: "/empresa",
        element: RegistrarEmpresaHome,
        allowedRoles: ['admin'],
        title: 'Registrar Empresa',
        icon: <ArchiveIcon size={20} />,
        description: 'Registrar Empresa',
        buttonText: 'Registrar Empresa',
        color: 'blue'
    },
    {
        path: "/registrarEmpresa",
        element: RegistrarEmpresa,
        allowedRoles: ['admin'],
    },
    {
        path: "/ver-registros",
        element: VerRegistrarEmpresa,
        allowedRoles: ['admin'],
    }
];